import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import { Box, Dialog, IconButton, Typography } from '@mui/material'
import type { SxProps, Theme } from '@mui/material/styles'
import { ReactNode } from 'react'
import { toast } from 'react-toastify'
type Props = {
  isOpen?: boolean
  handleClose: (value: boolean) => void
  children?: any
  title?: ReactNode
  width?: string
  sx?: SxProps<Theme>
  clickOutSite?: boolean
  pd?: string
  maxHeight?: string | number
  hiddenIcon?: boolean
}
export const PopupWrapper = ({
  isOpen,
  handleClose,
  children,
  title,
  width = '800px',
  sx,
  clickOutSite = true,
  pd,
  hiddenIcon = false,
  maxHeight,
}: Props) => {
  return (
    <Dialog
      sx={{
        '& .MuiPaper-root': {
          width: '100%',

          maxWidth: width,
          margin: '.5rem',
          padding: 0,
          borderRadius: '8px',
          zIndex: 9999,
        },
        ...sx,
      }}
      onClose={() => {
        if (clickOutSite) {
          handleClose(false)
        } else {
          // toast.info('Vui lòng sử dụng nút đóng để thoát khỏi cửa sổ này', {
          //   position: 'top-center',
          // })
        }
      }}
      open={isOpen ?? false}
    >
      <Box
        sx={{
          maxHeight: maxHeight || '80vh',
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: pd || '1rem',
          position: 'relative',
        }}
      >
        {!hiddenIcon && (
          <IconButton
            onClick={() => handleClose(false)}
            sx={{
              position: 'absolute',
              right: 6,
              top: 6,
              zIndex: 10,
              width: '1em',
              height: '1em',
              borderRadius: '.2em',
              transition: 'background-color 0.2s',
              '&:hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
              },
            }}
          >
            <CloseRoundedIcon sx={{ color: '#c2c2c2' }} />
          </IconButton>
        )}
        {title && (
          <Typography
            variant="h6"
            sx={{
              marginBottom: 2,
              fontSize: { xs: '1.2rem', md: '1.3em' },
              fontWeight: 600,
            }}
          >
            {title}
          </Typography>
        )}
        {children}
      </Box>
    </Dialog>
  )
}
